export default __webpack_public_path__ + "static/media/logo.958aaff6.png";